// extracted by mini-css-extract-plugin
export default {"root":"Pricing_root__4BzsR","goods":"Pricing_goods__vp8yV","form":"Pricing_form__6LzV0","pay":"Pricing_pay__H8VAh"};